import { Prices } from 'assets/dummy/collections'
import { ERCButton } from 'components/button'
import SideFilter from 'components/sidefilterr'
import { StoreCard } from 'components/store/card'
import Header from 'components/store/header'
import Layout from 'partials/layout'
import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Pagination from 'components/pagination/pagination'

const Studentstore = () => {
  const products = useSelector((state) => state?.product?.data?.product);
  
  
  const navigate = useNavigate()

  const handleViewDetails = (id) => {
    navigate(`/product-details/${id}`);
    window.scrollTo(0,0);
    }

    const [currentPage, setCurrentPage] = useState(1);
    // Pagination
  const PageSize = 6;
  const firstPageIndex = (currentPage - 1) * PageSize;
  const lastPageIndex = firstPageIndex + PageSize;
  const currentTableData = products?.slice(firstPageIndex, lastPageIndex);

  console?.log(currentTableData);
  const totalPages = Math?.ceil(products?.length / PageSize);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedRange, setSelectedRange] = useState(null);

  // price ranges filter
  const priceRanges = [
    { label: 'NGN 1,000 - NGN 20,000', min: 1000, max: 20000 },
    { label: 'NGN 21,000 - NGN 40,000', min: 21000, max: 40000 },
    { label: 'NGN 41,000 - NGN 60,000', min: 41000, max: 60000 },
    { label: 'NGN 61,000 - NGN 99,000', min: 61000, max: 99000 },
    { label: 'NGN 100,000 and above', min: 100000, max: Infinity },
  ];

  useEffect(() => {
    if (selectedRange) {
      const filtered = products?.filter(product => {
        const discountedPrice = product?.price - (product?.price * (product?.discount / 100));
        return discountedPrice >= selectedRange?.min && discountedPrice <= selectedRange?.max;
      });
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(products); // Default to all products if no range selected
    }
  }, [products, selectedRange]);

  const handleRangeChange = (range) => {
    // Toggle selection
    setSelectedRange(selectedRange === range ? null : range);
  };



  return (
    <Layout>
      <Header  />
        <div className='flex ml-[45px] pt-[10px] gap-[5px] cursor-pointer' onClick={() => {window.scrollTo(0,0); navigate("/store")}}>
<img src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721893028/ERC/drowdown-arrow_suwan5.svg" />
<p> Go Back</p>
</div>

<div className='mx-[12.5%] pt-[60px]'>
    <h2 className='text-[#292930] font-manrope text-[24px] leading-[32px] font-semibold'>Filters</h2>
</div>

<div className='w-full flex justify-center gap-[150px] pt-[20px]'>
<div className=' w-[300px]  ml-[50px] border h-[620px]'>
  <div className='border-b border-b-[#FFD600] pb-[15px]'>
    <div className='flex gap-[200px]'>
   <h3 className='text-[#292930] font-manrope text-[16px] leading-[24px] font-semibold'>Products</h3>
   <img src='https://res.cloudinary.com/dmrtylvtc/image/upload/v1721894292/ERC/wzstjb1jgkg2vbbbooyu.svg'/>
   </div>
  </div>
  <div className='bg-[#F0F0F0] pb-[10px] pt-[1px]'>
   <div className='flex gap-[10px] mt-[20px] pl-[15px]'>
   <ERCButton size="16px" weight={'600'} color={'#706E73'} border={'1px solid #CFCFCF'} h={'#FFD600'} bgcolor={'white'} width='80px'>Books</ERCButton>
   <ERCButton size="16px" weight={'600'} color={'#706E73'} border={'1px solid #CFCFCF'} h={'#FFD600'} bgcolor={'white'} width='80px'>GAMES</ERCButton>
   </div>
  
   <div className='flex gap-[10px] pt-[10px] pl-[15px]'>
   <ERCButton size="16px" weight={'600'} color={'#706E73'} border={'1px solid #CFCFCF'} h={'#FFD600'} bgcolor={'white'} width='120px'>School Items</ERCButton>
   <ERCButton size="16px" weight={'600'} color={'#706E73'} border={'1px solid #CFCFCF'} h={'#FFD600'} bgcolor={'white'} width='90px'>Materials</ERCButton>
   </div>

   <div className='pt-[10px] pl-[15px]'><ERCButton size="16px" weight={'600'} color={'#706E73'} border={'1px solid #CFCFCF'} h={'#FFD600'} bgcolor={'white'} width='120px'>Learning Aids</ERCButton></div>
   </div>
   {/*  discount */}

   <div className='border-b border-b-[#FFD600] pb-[15px] flex gap-[185px] pt-[20px]'>
        <h2 className='text-[#292930] font-manrope text-[16px] leading-[24px] font-semibold'> Discount %</h2>
        <img src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721894292/ERC/add_jkk79f.svg" />
        </div>

{/* prices */}

        <div className='border-b border-b-[#FFD600] pb-[15px] flex gap-[225px] pt-[20px]'>
        <h2 className='text-[#292930] font-manrope text-[16px] leading-[24px] font-semibold'> Prices</h2>
        <img src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721894292/ERC/add_jkk79f.svg" />
        </div>
        <div className="w-full p-6 bg-gray-100 border border-gray-300 rounded-md shadow-sm">
  {priceRanges?.map((range) => (
    <label key={range.label} className="flex items-center cursor-pointer relative">
      <input
        type="checkbox"
        value={`${range.min}-${range.max}`}
        onChange={() => handleRangeChange(range)}
        className="peer"
        // checked={selectedRange === range}
      />
      <div
        className={`flex items-center justify-center w-full p-2 cursor-pointer ${selectedRange === range ? 'bg-[#00296B]' : ''}`}
      >
        {range.label}
      </div>
    </label>
  ))}
</div>


        {/* <div className='flex item-center justify-center pt-[30px] gap-[10px]'>
          <ERCButton size="16px" weight={'600'} color={'#706E73'} border={'1px solid #CFCFCF'} h={'#FFD600'} bgcolor={'white'} width='100px'>Clear All</ERCButton>
          <ERCButton size="16px" weight={'600'} color={'white'} border={'1px solid #CFCFCF'} h={'#FFD600'} bgcolor={'#00296B'} width='120px'>Apply Filter</ERCButton>
        </div> */}
</div>
        <div className='mb-[220px]'>
     <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[40px] gap-y-[120px]'>
        {products ?.length > 0 ? (
          // currentTableData
          (filteredProducts || currentTableData)?.map(product => (
            <StoreCard
              key={product?.id}
              title={product?.name}
              slashPrice={`NGN ${product?.price}`}
              discount={`-${product?.discount}%`}
              amount={`NGN ${product?.price - (product?.price * (product?.discount / 100))}`}
              number={"1000"}
              img={product?.productImage[0]}
              viewDetails={"View Details"}
              onClick={() => handleViewDetails(product?.id)}
            />
          ))
        ) : (
          <p className='flex justify-center items-center text-2xl'>No products available</p>
        )}
      </div> 
                    <div className='w-full px-10 mt-32'> 
             <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
           </div>

        </div>
        </div>
    </Layout>
  )
}

export default Studentstore
